import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { distinct, from, tap } from 'rxjs';
import { DpModuleService } from 'src/app/dp-module/dp-module.service';
import { ProfileService } from '../../services/profile.service';
import { EditReasonComponent } from '../../../master/project/edit-reason/edit-reason.component';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-reject-annual-report-module',
  templateUrl: './reject-annual-report-module.component.html',
  styleUrls: ['./reject-annual-report-module.component.scss']
})
export class RejectAnnualReportModuleComponent implements OnInit {
  @Input() listDpModuleList;
  rejectAnnualConfirmFilter = [];
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  rejectAnnualConfirmForm : FormGroup;
  rejectOldAnnualConfirmForm : FormGroup;
  button = 'Send';
  isLoading = false;
  listDpModule: any;
  listDpEmail:any = [];
  newDate = new Date();
  currentDate: any;
  financialyear: string;
  getId: any;
  count: any;
  submitted:boolean = false;
  immediatRelativesPerson:any;
  d = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
  ];
  
  p = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
  ];

  immediateNameValid: any;
  showButton: boolean;
  editReason: any;
  constructor(public activeModal: NgbActiveModal, public router: Router, private fb:FormBuilder, private toastr: ToastrService,
    private profileService: ProfileService, private dpService:DpModuleService,private modalService: NgbModal) { }
    createImmediateRelative(){
      return this.fb.group({
        imr_id: new FormControl(''),
        name: new FormControl(''),
        relationship: new FormControl(''),
        phone_no: new FormControl(''),
        pan: new FormControl(''),
        DocumentType: new FormControl(''),
        relativeemail: new FormControl('')
      })
    }
    i:number;
    addInputControls(){
      // this.procedureCont = true;
      const add = this.rejectAnnualConfirmForm.get('immediateDpRelative') as FormArray;
     
      add.push(this.createImmediateRelative()) 
      this.count = this.rejectAnnualConfirmForm.get('immediateDpRelative');
      // let item1 = this.count.find(i => i.imr_id === this.rejectAnnualConfirmForm.get('immediateDpRelative'));
     
      // let item1 = this.count.find(i => i.imr_id === this.count.imr_id);
      // console.log('count2', item1)
    //   for(let i = 1; i === this.count.value[i].imr_id; i++){
    //     this.count = i+1;
    //     console.log("i", this.count)
    // }
  
    }
    addOldInputControls(){
      // this.procedureCont = true;
      const add = this.rejectOldAnnualConfirmForm.get('immediateDpRelative') as FormArray;
     
      add.push(this.createImmediateRelative()) 
     
  
    }
    removeInputControls(idx: number){
      const add = this.rejectAnnualConfirmForm.get('immediateDpRelative') as FormArray;  
      add.removeAt(idx); 
      this.count = this.rejectAnnualConfirmForm.get('immediateDpRelative')?.value.length;
        
  }
 //Annual Confiremation
createAnnualConfirmation(){
  return this.fb.group({
    id: new FormControl(''),
    financialYearSymbol: new FormControl('FY'),
    financialYear: new FormControl(''),
    lastConformedDate: new FormControl(''),
  })
}
addInputControlsAnnual(){
  // this.procedureCont = true;
  const add = this.rejectAnnualConfirmForm.get('annualConfirmation') as FormArray;
  add.push(this.createAnnualConfirmation()) 
}
addOldInputControlsAnnual(){
  // this.procedureCont = true;
  const add = this.rejectOldAnnualConfirmForm.get('annualConfirmation') as FormArray;
  add.push(this.createAnnualConfirmation()); 
}
removeInputControlsAnnual(idx: number){
  const add = this.rejectAnnualConfirmForm.get('annualConfirmation') as FormArray;  
  add.removeAt(idx);   
}

  ngOnInit(): void {
      this.getId = {'id': this.listDpModuleList.id}
    this.rejectAnnualConfirmFilter =[];
    if(this.getId['id'] !==''){
      this.dpService.viewDpModule(this.getId)
      .toPromise().then(result =>{       
        this.immediatRelativesPerson = result.data[0].immediateDpRelative ;
        result.data[0].immediateDpRelative = result.data[0].immediateDpRelative;
        if( this.immediatRelativesPerson &&  this.immediatRelativesPerson.length > 1){
          for(let i = 1;i<  this.immediatRelativesPerson.length; i++ ) {
            this.addInputControls();
          }
        }
        if( this.immediatRelativesPerson &&  this.immediatRelativesPerson.length > 1){
          for(let i = 1;i<  this.immediatRelativesPerson.length; i++ ) {
            this.addOldInputControls();
          }
        }
        //annualConformation data
        let annualConformationData = result.data[0].annualConfirmation ;
        result.data[0].annualConfirmation = result.data[0].annualConfirmation;
        if( annualConformationData &&  annualConformationData.length > 1){
          for(let i = 1;i<  annualConformationData.length; i++ ) {
            this.addInputControlsAnnual();
          }
        }
        if( annualConformationData &&  annualConformationData.length > 1){
          for(let i = 1;i<  annualConformationData.length; i++ ) {
            this.addOldInputControlsAnnual();
          }
        }
        this.rejectAnnualConfirmForm.patchValue(result.data[0]);
        this.rejectOldAnnualConfirmForm.patchValue(result.data[0]);
        this.rejectAnnualConfirmForm.statusChanges.subscribe(status => {
          const isEqual = this.areObjectsEqual(this.rejectAnnualConfirmForm.value, this.rejectOldAnnualConfirmForm.value);
          if(!isEqual){
            this.showButton = true;
          }else{
            this.showButton = false;
          }
        });

      })
    this.rejectAnnualConfirmForm = this.fb.group({
      role_name: new FormControl ('',  Validators.required),
      content_text: new FormControl ('',  Validators.required),  
      id : new FormControl(''),
      dpName: new FormControl('',  [Validators.required,Validators.pattern("[a-zA-Z _.,-]*")]),
      dpDesignation: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&-]+$')]), 
      email: new FormControl ('', [Validators.required,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z/\| ]{2,}$')]),
      alternativeemail: new FormControl ('', [Validators.required,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z/\| ]{2,}$')]),
      dpPanNo: new FormControl ('',  [Validators.required]),
      DocumentType: new FormControl ('', [Validators.required]),
      dpContactNo: new FormControl ('',  [Validators.required, Validators.pattern("^((\\+?)|0)?[0-9\ \-]+$")]),
      // withWhom: new FormControl ('',  Validators.required),
      dpEducationalInstitute: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&-]+$')]),
      dpAddress: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z\n0-9 _.,/()#&-]+$')]),
      dpPastEmp: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&-]+$')]),
      immediateDpRelative : new FormArray([this.createImmediateRelative()]),
      annualConfirmation : new FormArray([this.createAnnualConfirmation()]),

    });
    this.rejectOldAnnualConfirmForm = this.fb.group({
      role_name: new FormControl ('',  Validators.required),
      content_text: new FormControl ('',  Validators.required),  
      id : new FormControl(''),
      dpName: new FormControl('',  [Validators.required,Validators.pattern("[a-zA-Z _.,-]*")]),
      dpDesignation: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&-]+$')]), 
      email: new FormControl ('', [Validators.required,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z/\| ]{2,}$')]),
      alternativeemail: new FormControl ('', [Validators.required,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z/\| ]{2,}$')]),
      dpPanNo: new FormControl ('',  [Validators.required]),
      DocumentType: new FormControl ('', [Validators.required]),
      dpContactNo: new FormControl ('',  [Validators.required, Validators.pattern("^((\\+?)|0)?[0-9\ \-]+$")]),
      // withWhom: new FormControl ('',  Validators.required),
      dpEducationalInstitute: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&-]+$')]),
      dpAddress: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z\n0-9 _.,/()#&-]+$')]),
      dpPastEmp: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&-]+$')]),
      immediateDpRelative : new FormArray([this.createImmediateRelative()]),
      annualConfirmation : new FormArray([this.createAnnualConfirmation()]),
    });

  }
    this.selectedItems = [];
 
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select the Admin',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };
    
    this.dpService.dpModuleList(null).subscribe(
      res => {
        
      this.listDpModule = res['data'];  
          
    //Get email
    this.listDpModule.map((role,email) => {
     
     
       if(role.role == 'Admin'){
        this.listDpEmail.push({id:role.id, itemName:role.email});
       
       }
    })
   
    this.rejectAnnualConfirmFilter = [];
    from(this.listDpEmail)
    .pipe(
    tap(item => item),
    distinct((d:any) => d.itemName)
    )
    .subscribe((r:any) => this.rejectAnnualConfirmFilter.push(r));
        
        },
        err => {
            console.log(err);
        }
    );

    //Date
    this.getCurrentFinancialYear()

//Current Date
const date = new Date();
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();
this.currentDate = day + '-' + month + '-' + year;
  }
  getValidity(i) {
    return (<FormArray>this.rejectAnnualConfirmForm.get('immediateDpRelative')).controls[i].invalid;
  }


  getCurrentFinancialYear() {
    this.financialyear = "";
    var today = new Date();
    if ((today.getMonth() + 1) <= 3) {
      this.financialyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
      this.financialyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    
    return this.financialyear
  
  }
  closeModal(sendData) {
    this.activeModal.close(sendData);
  }
  cancelProject(){
    this.activeModal.close(event);   
    this.rejectAnnualConfirmForm.reset();
  }
   //Multi select box
   onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }
  //AAdharValidation
validate(addharNumber) {
  let c = 0;
  let invertedArray = addharNumber
    .split('')
    .map(Number)
    .reverse();

  invertedArray.forEach((val, i) => {
    c = this.d[c][this.p[i % 8][val]];
  });

  return c === 0;
}
areObjectsEqual(a: any, b: any): boolean {
  const aString = JSON.stringify(a);
  const bString = JSON.stringify(b);

  return aString === bString;
}
findChangedKeyValues(objA: any, objB: any): any {
  const resultA: any = {};
  const resultB: any = {};

  for (const key in objA) {
    if(key != 'id'){
      if (objA.hasOwnProperty(key) && objB.hasOwnProperty(key)) {
        if (JSON.stringify(objA[key]) !== JSON.stringify(objB[key])) {          
          resultA[key] = objA[key];
          resultB[key] = objB[key];          
        }
      } else {
        
          resultA[key] = objA[key];
        
      }
    }
  }

  for (const key in objB) {
    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
      resultB[key] = objB[key];
    }
  }

  return {
    "oldData": resultA,
    "newData": resultB
  };
}

openModalEditReason() {
  if(this.rejectAnnualConfirmForm.controls.dpName.errors?.pattern != undefined){
    this.toastr.warning('Enter Name accept text format only')
    return false;
  }else if(this.rejectAnnualConfirmForm.controls.alternativeemail.errors?.pattern != undefined){
    this.toastr.warning('Your Alternative Email Id is InValid')
    return false;
  }else if(this.rejectAnnualConfirmForm.controls.email.errors?.pattern != undefined){
    this.toastr.warning('Your Email Id is InValid')
    return false;
  }
  else if(this.rejectAnnualConfirmForm.controls.dpContactNo.errors?.pattern != undefined){
    this.toastr.warning('Enter Contact Number accept number format only')
    return false;
  }

  const emptyFileds = Object.keys(this.rejectAnnualConfirmForm.controls).filter(key =>this.rejectAnnualConfirmForm.controls[key].errors !== null)

let currdate = new Date();
let curr_date = formatDate(currdate, 'yyyy-MM-dd', 'en-US');
if(this.rejectAnnualConfirmForm.get('annualConfirmation')['controls'].length > 0){
  for(let i=0; i<this.rejectAnnualConfirmForm.get('annualConfirmation')['controls'].length; i++){
    if(this.rejectAnnualConfirmForm.get('annualConfirmation')['controls'][i]['controls'].lastConformedDate.value != ''){
      if(this.rejectAnnualConfirmForm.get('annualConfirmation')['controls'][i]['controls'].lastConformedDate.value > curr_date ){
        this.toastr.warning( 'Enter the ' + [i + 1] + ' row  Valid Last Confirmed Date.')
          return false;  
      }
    }
  }

}
let idendiferCard = this.rejectAnnualConfirmForm.get('dpPanNo')?.value;
      if(this.rejectAnnualConfirmForm.get('DocumentType')?.value == 'PAN'){
        
        let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
        if (!regex.test(idendiferCard)) {
          this.toastr.warning("Please Enter the Valid PAN.");
         // this.messageValid = 'Please Enter the Valid PAN.';
         return false;
        }
      }else if(this.rejectAnnualConfirmForm.get('DocumentType')?.value == 'Aadhar card'){
        
        let regex = new RegExp(/^[A-Z]{0}[0-9]{12}[A-Z]{0}$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter Valid Aadhar Number');
          return false;
        }else{
        if (this.validate(idendiferCard) && idendiferCard) {         
        } else {
          this.toastr.warning('Your Aadhar Number is InValid')
          return false;      
        }

      }
      }else if(this.rejectAnnualConfirmForm.get('DocumentType')?.value == 'Voter ID'){
        let regex = new RegExp(/^([a-zA-Z]){3}([0-9]){7}?$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter Valid Voter ID');
          return false;
        }
    }else if(this.rejectAnnualConfirmForm.get('DocumentType')?.value == 'Driving License'){
      let regex = new RegExp(/^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter Valid Driving License');
          return false;
        }
    }
    if(this.rejectAnnualConfirmForm.get('confidentiality_agreement_entered')?.value == 'Yes'){
      if(this.rejectAnnualConfirmForm.get('confidentiality_agreement_date')?.value == null || this.rejectAnnualConfirmForm.get('confidentiality_agreement_date')?.value == ''){
        this.toastr.warning('Please Enter the Confidentiality Agreement Date');
        return false;
      }
    }
    //Immidiate relative
    if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'].length > 0){
      for(let i=0; i<this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'].length; i++){
        if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].pan?.value != '' && this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].DocumentType?.value ==''){
          this.toastr.warning( 'Enter the ' + [i + 1] + ' row ID Proof No.')
            return false;  
        }
        let idendiferCard = this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].pan?.value;
        if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].DocumentType?.value == 'PAN'){
          
          let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
          if (!regex.test(idendiferCard)) {
            this.toastr.warning("Please Enter the "+ [i + 1 ] + " row Valid PAN.");
           // this.messageValid = 'Please Enter the Valid PAN.';
           return false;
          }
        }else if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].DocumentType?.value == 'Aadhar card'){
          let regex = new RegExp(/^[A-Z]{0}[0-9]{12}[A-Z]{0}$/);
          if(!regex.test(idendiferCard)){
            this.toastr.warning('Please Enter ' + [i + 1] + ' row Valid Aadhar Number');
            return false;
          }else{
          if (this.validate(idendiferCard) && idendiferCard) {         
          } else {
            this.toastr.warning( [i + 1] + ' row Your Aadhar Number is InValid')
            return false;      
          }
        }
      }else if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].DocumentType.value == 'Voter ID'){
        let regex = new RegExp(/^([a-zA-Z]){3}([0-9]){7}?$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter ' + [i + 1] + ' row Valid Voter ID');
          return false;
        }
    }else if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].DocumentType.value == 'Driving License'){
      let regex = new RegExp(/^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter ' + [i + 1] + ' row Valid Driving License ');
          return false;
        }
    }else if(this.rejectAnnualConfirmForm.get('immediateDpRelative')['controls'][i]['controls'].phone_no.errors?.pattern != undefined){
      this.toastr.warning('Enter ' + [i + 1] + ' row Contact Number accept number format only')
      return false;
    }
    
      }
  
    }

    if(emptyFileds.length > 1){
      this.toastr.warning("Please fill all Mandatory fields.");
      return false;
    }else{
      if(this.rejectAnnualConfirmForm.get('dpName')?.value == ''){
        this.toastr.warning("Please fill the Name.");
        return false;
      }else if(this.rejectAnnualConfirmForm.get('dpDesignation')?.value == ''){
        this.toastr.warning("Please fill the Designation.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('email')?.value == ''){
        this.toastr.warning("Please fill the Email ID.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('alternativeemail')?.value == ''){
        this.toastr.warning("Please fill the Alternative Email ID.");
      }
      else if(this.rejectAnnualConfirmForm.get('dpContactNo')?.value == ''){
        this.toastr.warning("Please fill the Contact Number.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('dpPanNo')?.value == ''){
        this.toastr.warning("Please fill the ID Proof Type.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('DocumentType')?.value == ''){
        this.toastr.warning("Please fill the ID Proof No.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('dpAddress')?.value == ''){
        this.toastr.warning("Please fill the Address.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('dpEducationalInstitute')?.value == ''){
        this.toastr.warning("Please fill the Educational Institute Name, Last Graduated From.");
        return false;
      }
      else if(this.rejectAnnualConfirmForm.get('dpPastEmp')?.value == ''){
        this.toastr.warning("Please fill the Company Name of Previous Job.");
        return false;
      }
      // else if(this.rejectAnnualConfirmForm.get('categoryofperson').value == ''){
      //   this.toastr.warning("Please fill the Category of Person.");
      // }
    }

  const isEqual = this.areObjectsEqual(this.rejectAnnualConfirmForm.value, this.rejectOldAnnualConfirmForm.value);
  if(!isEqual){
    const modalRef = this.modalService.open(EditReasonComponent,
      {
        scrollable: true,
        windowClass: 'myCustomModalClass',
      });
    modalRef.result.then((result) => {
      // console.log("result", result);
      this.editReason=result;
      if(this.editReason != 'dismiss'){
        this.onSubmit();
      }
    }, (reason) => {
    });
  }
  
}
  //multi select box
  onSubmit(){    
   
  this.submitted = true;
  if(this.rejectAnnualConfirmForm.status !== 'INVALID'){
  this.isLoading = true;
    this.button = 'Processing';
    // this.rejectAnnualConfirmForm?.value.annualConfirmDetails = this.listDpModuleList;
    this.rejectAnnualConfirmForm.value.financialyear = this.financialyear;
    this.rejectAnnualConfirmForm.value.currentDate= this.currentDate
    this.rejectAnnualConfirmForm.value.annualconformmail= 'annualconformmail';
    //console.log("1222", this.rejectAnnualConfirmForm?.value)
    const changedKeyValues = this.findChangedKeyValues(this.rejectOldAnnualConfirmForm.value,this.rejectAnnualConfirmForm.value);
        
    let reqObj = {
      data:changedKeyValues,
      id:this.listDpModuleList.id,
      editReason:this.editReason
    }
    this.dpService.updateDpModule(reqObj).subscribe(data =>{
        this.button = 'Send';
        this.isLoading = false;
          this.toastr.success("Annual Confirmation Details Successfully Sented");
          this.activeModal.close(event);
          //window.location.href;
       
      })
    }
  }
}
